<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">Summary AR by Customer
        <div class="card-header-actions">
          <button class="btn btn-primary mr-1" @click="showPrintConfirm=true">
              <i class="fa fa-print"></i> Print
          </button>
         <button class="btn btn-primary mr-1" @click="exportxls()">
              <i class="fa fa-file-excel-o"></i>
              Export
          </button>
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row >
        <b-col lg="6">
            <b-input-group >
              <b-input-group-prepend>
                <span v-if="(model.exclude==1)" class="p-2">A/R Account Exclude</span>
                <span v-else class="p-2">A/R Account Equal</span>
              </b-input-group-prepend>
              <b-form-checkbox v-model="model.exclude" :value="1" :unchecked-value="0" switch class="pt-2"></b-form-checkbox>
              <b-form-select v-model="model.account" :plain="true" :options="accounts" style="width:30% !important;"></b-form-select>
              <b-input-group-prepend><span class="input-group-text">GL Acc.#</span></b-input-group-prepend>
              <b-form-input v-model="model.kodeacc" readonly placeholder="GL Account Code"></b-form-input>
            </b-input-group>
        </b-col>
        <b-col lg="5">
            <b-input-group >
              <b-input-group-prepend><span class="p-2">As Of Date</span></b-input-group-prepend>
              <b-form-input v-model="model.tgl2" type="date"></b-form-input>
              <b-form-checkbox class="ml-1 mt-2 text-left" v-model="model.excludezero" value=1 unchecked-value=0 >Exclude Zero Outstandings</b-form-checkbox>
              <b-input-group-append><b-button class="ml-3 btn btn-success" @click="getData()" > <i class="fa fa-play"></i> Process</b-button></b-input-group-append>
            </b-input-group>
        </b-col>
      </b-row>
      <b-card no-body v-show="showSummary" >
        <b-tabs card v-model="model.tabIndex">
          <b-tab title="Summary in Local Currency (LCY)" active>
            <b-row v-if="(filterShow=='Hide')">
                <b-col lg="6">
                    <b-form-group
                        label="Filter"
                        label-cols-sm="1"
                        label-size="sm"
                        label-for="filter"
                        class="mb-0"
                        >
                        <b-input-group size="sm">
                            <b-form-input
                            v-model="filter"
                            type="search"
                            id="filter"
                            placeholder="Type to Search"
                            ></b-form-input>
                            <b-input-group-append>
                            <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                            </b-input-group-append>
                        </b-input-group>
                        </b-form-group>            
                </b-col>         
                <b-col lg="6">
                        <b-form-checkbox v-model="filterShow" value="Hide" unchecked-value="Show" switch>
                          <b> {{ filterShow }}</b> Filter
                        </b-form-checkbox>
                </b-col>         
            </b-row>
            <b-table
                class="mb-0"
                ref="tableLcy"
                sticky-header="600px" outlined responsive striped hover
                style="font-size:smaller;"
                :items="aging.rekapVendor"
                :fields="tblLcy.fields"
                :current-page="tblLcy.page"
                :per-page="tblLcy.limit"
                :sort-by.sync="tblLcy.sortBy"
                :sort-desc.sync="tblLcy.sortDesc"
                :filter="filterInput"
                :filterIncludedFields="filterOn"
                @filtered="onFiltered"                
            >
              <template v-slot:cell(custcode)="data">
                <b-link @click.stop="getCustDtl(data.item)">{{data.item.custcode}}</b-link>
              </template>

                <template v-slot:head(totalLcy)="data">
                  <span >Total Outstand in {{uanguser}} (Local Currency)</span>
                </template>
                <template v-slot:cell(totalLcy)="data">
                    {{ data.item.totalLcy | numFormat }}
                </template>
                <template v-slot:head(aging1Lcy)="data">
                  <span v-if="(aging.seting.arAge1)" class="text-info">CURRENT</span>
                  <span v-else class="text-info">CURRENT</span>
                </template>
                <template v-slot:cell(aging1Lcy)="data">
                      {{ data.item.aging1Lcy | numFormat }}
                </template>
                <template v-slot:head(aging2Lcy)="data">
                  <span v-if="(aging.seting.arAge2)" class="text-info">{{aging.seting.arAge2-aging.seting.arAge1}} Days</span>
                  <span v-else class="text-info">30 Days</span>
                </template>
                <template v-slot:cell(aging2Lcy)="data">
                      {{ data.item.aging2Lcy | numFormat }}
                </template>
                <template v-slot:head(aging3Lcy)="data">
                  <span v-if="(aging.seting.arAge3)" class="text-info">{{aging.seting.arAge3-aging.seting.arAge1}} Days</span>
                  <span v-else class="text-info">60 Days</span>
                </template>
                <template v-slot:cell(aging3Lcy)="data">
                      {{ data.item.aging3Lcy | numFormat }}
                </template>
                <template v-slot:head(aging4Lcy)="data">
                  <span v-if="(aging.seting.arAge4)" class="text-info">{{aging.seting.arAge4-aging.seting.arAge1}} Days</span>
                  <span v-else class="text-info">90 Days</span>
                </template>
                <template v-slot:cell(aging4Lcy)="data">
                      {{ data.item.aging4Lcy | numFormat }}
                </template>
                <template v-slot:head(aging5Lcy)="data">
                  <span v-if="(aging.seting.arAge5)" class="text-info">{{aging.seting.arAge5-aging.seting.arAge1}} Days</span>
                  <span v-else class="text-info"> 120 Days</span>
                </template>
                <template v-slot:cell(aging5Lcy)="data">
                      {{ data.item.aging5Lcy | numFormat }}
                </template>

                <template v-slot:head(aging6Lcy)="data">
                  <span v-if="(aging.seting.arAge5)" class="text-info"> > {{aging.seting.arAge5-aging.seting.arAge1}} Days</span>
                  <span v-else class="text-info"> > 180 Days</span>
                </template>
                <template v-slot:cell(aging6Lcy)="data">
                      {{ data.item.aging6Lcy | numFormat }}
                </template>
            </b-table>
            <b-row class="mt-2">
                <b-col cols="4">
                    <div style="font-weight: bolder;">Total Outstanding : {{uanguser}} {{aging.totalLcy | numFormat}}</div>
                </b-col>
                <b-col cols="8">
                    <b-row >
                      <b-col cols="6" style="text-align:center">
                        <div>
                          Showing {{(tblLcy.page - 1) * tblLcy.limit + 1}}
                          to <span v-if="((tblLcy.page * tblLcy.limit)>tblLcy.total)">{{tblLcy.total}}</span> <span v-else>{{tblLcy.page * tblLcy.limit}}</span>
                          of {{tblLcy.total}} entries,   <span class="ml-3 mr-1">limit per page :</span> 
                          <select  v-model="tblLcy.limit"  style="width:60px;">
                            <option>10</option>
                            <option>20</option>
                            <option>30</option>                            
                            <option>40</option>
                            <option>50</option>                            
                            <option>60</option>                            
                            <option>70</option>                            
                            <option>80</option>                            
                            <option>90</option>                            
                            <option>100</option>                            
                          </select>
                        </div>
                        <b-form-checkbox v-model="filterShow" value="Hide" unchecked-value="Show" switch>
                          <b> {{ filterShow }}</b> Filter
                        </b-form-checkbox>
                      </b-col>
                      <b-col cols="6">            
                        <b-pagination 
                          align="right"
                          :total-rows="tblLcy.total"
                          :per-page="tblLcy.limit"
                          v-model="tblLcy.page"
                        ></b-pagination>
                      </b-col>
                    </b-row>
                </b-col>
            </b-row>
          </b-tab>
          <b-tab title="Summary in Original Currency">
            <b-row v-if="(filterOriShow=='Hide')">
                <b-col lg="6">
                    <b-form-group
                        label="Filter"
                        label-cols-sm="1"
                        label-size="sm"
                        label-for="filterOriInput"
                        class="mb-0"
                        >
                        <b-input-group size="sm">
                            <b-form-input
                            v-model="filterOri"
                            type="search"
                            id="filterOriInput"
                            placeholder="Type to Search"
                            ></b-form-input>
                            <b-input-group-append>
                            <b-button :disabled="!filterOri" @click="filterOri = ''">Clear</b-button>
                            </b-input-group-append>
                        </b-input-group>
                        </b-form-group>            
                </b-col>         
                <b-col lg="6">
                        <b-form-checkbox v-model="filterOriShow" value="Hide" unchecked-value="Show" switch>
                          <b> {{ filterOriShow }}</b> Filter
                        </b-form-checkbox>
                </b-col>         
            </b-row>
            <b-table
                class="mb-0"
                ref="tableOri"
                sticky-header="600px" outlined responsive striped hover
                style="font-size:smaller;"
                :items="aging.rekap"
                :fields="tblOri.fields"
                :current-page="tblOri.page"
                :per-page="tblOri.limit"
                :sort-by.sync="tblOri.sortBy"
                :sort-desc.sync="tblOri.sortDesc"
                :filter="filterOriInput"
                :filterIncludedFields="filterOriOn"
                @filtered="onFilteredOri"                
            >
              <template v-slot:cell(custcode)="data">
                <b-link @click.stop="getCustDtl(data.item)">{{data.item.custcode}}</b-link>
              </template>

                <template v-slot:cell(totalOri)="data">
                    {{ data.item.totalOri | numFormat }}
                </template>
                <template v-slot:head(totalLcy)="data">
                  <span >Total Outstand in {{uanguser}} (Local Currency)</span>
                </template>
                <template v-slot:cell(totalLcy)="data">
                    {{ data.item.totalLcy | numFormat }}
                </template>
                <template v-slot:head(aging1Ori)="data">
                  <span v-if="(aging.seting.arAge1)" class="text-info">CURRENT</span>
                  <span v-else class="text-info">CURRENT</span>
                </template>
                <template v-slot:cell(aging1Ori)="data">
                      {{ data.item.aging1Ori | numFormat }}
                </template>
                <template v-slot:head(aging2Ori)="data">
                  <span v-if="(aging.seting.arAge2)" class="text-info">{{aging.seting.arAge2-aging.seting.arAge1}} Days</span>
                  <span v-else class="text-info">30 Days</span>
                </template>
                <template v-slot:cell(aging2Ori)="data">
                      {{ data.item.aging2Ori | numFormat }}
                </template>
                <template v-slot:head(aging3Ori)="data">
                  <span v-if="(aging.seting.arAge3)" class="text-info">{{aging.seting.arAge3-aging.seting.arAge1}} Days</span>
                  <span v-else class="text-info">60 Days</span>
                </template>
                <template v-slot:cell(aging3Ori)="data">
                      {{ data.item.aging3Ori | numFormat }}
                </template>
                <template v-slot:head(aging4Ori)="data">
                  <span v-if="(aging.seting.arAge4)" class="text-info">{{aging.seting.arAge4-aging.seting.arAge1}} Days</span>
                  <span v-else class="text-info">90 Days</span>
                </template>
                <template v-slot:cell(aging4Ori)="data">
                      {{ data.item.aging4Ori | numFormat }}
                </template>
                <template v-slot:head(aging5Ori)="data">
                  <span v-if="(aging.seting.arAge5)" class="text-info">{{aging.seting.arAge5-aging.seting.arAge1}} Days</span>
                  <span v-else class="text-info"> 120 Days</span>
                </template>
                <template v-slot:cell(aging5Ori)="data">
                      {{ data.item.aging5Ori | numFormat }}
                </template>

                <template v-slot:head(aging6Ori)="data">
                  <span v-if="(aging.seting.arAge5)" class="text-info"> > {{aging.seting.arAge5-aging.seting.arAge1}} Days</span>
                  <span v-else class="text-info"> > 180 Days</span>
                </template>
                <template v-slot:cell(aging6Ori)="data">
                      {{ data.item.aging6Ori | numFormat }}
                </template>
            </b-table>
            <b-row class="mt-2">
                <b-col cols="4">
                    <div style="font-weight: bolder;">Total Outstanding : {{uanguser}} {{aging.totalLcy | numFormat}}</div>
                </b-col>
                <b-col cols="8">
                    <b-row >
                      <b-col cols="6" style="text-align:center">
                        <div>
                          Showing {{(tblOri.page - 1) * tblOri.limit + 1}}
                          to <span v-if="((tblOri.page * tblOri.limit)>tblOri.total)">{{tblOri.total}}</span> <span v-else>{{tblOri.page * tblOri.limit}}</span>
                          of {{tblOri.total}} entries,   <span class="ml-3 mr-1">limit per page :</span> 
                          <select  v-model="tblOri.limit"  style="width:60px;">
                            <option>10</option>
                            <option>20</option>
                            <option>30</option>                            
                            <option>40</option>
                            <option>50</option>                            
                            <option>60</option>                            
                            <option>70</option>                            
                            <option>80</option>                            
                            <option>90</option>                            
                            <option>100</option>                            
                          </select>
                        </div>
                        <b-form-checkbox v-model="filterOriShow" value="Hide" unchecked-value="Show" switch>
                          <b> {{ filterShow }}</b> Filter
                        </b-form-checkbox>
                      </b-col>
                      <b-col cols="6">            
                        <b-pagination 
                          align="right"
                          :total-rows="tblOri.total"
                          :per-page="tblOri.limit"
                          v-model="tblOri.page"
                        ></b-pagination>
                      </b-col>
                    </b-row>
                </b-col>
            </b-row>
          </b-tab>

          <b-tab title="Detail Outstanding">
            <b-row v-if="(filterDtlShow=='Hide')">
                <b-col lg="4">
                  <b-input-group size="sm">
                      <b-form-checkbox v-model="filterDtlShow" value="Hide" unchecked-value="Show" switch></b-form-checkbox>
                      <b-input-group-prepend> <span class="pr-2">
                          <b> {{ filterDtlShow }}</b>  Filter </span>
                      </b-input-group-prepend>
                      <b-form-input v-model="filterDtl" type="search" placeholder="Type to Search"></b-form-input>
                      <b-input-group-append>
                          <b-button :disabled="!filterDtl" @click="filterDtl = ''">Clear</b-button>
                      </b-input-group-append>
                  </b-input-group>
                </b-col>         
                <b-col lg="8">
                  <b-input-group >
                    <b-input-group-prepend><span class="pt-1 pr-2">Filter On</span></b-input-group-prepend>
                          <b-form-checkbox-group v-model="filterDtlOn" class="mt-1">
                            <b-form-checkbox value="custcode">Customer Code</b-form-checkbox>
                            <b-form-checkbox value="CustName">Customer Name</b-form-checkbox>
                            <b-form-checkbox value="nomor">Invoice No.</b-form-checkbox>
                            <b-form-checkbox value="monumber">MO Number</b-form-checkbox>
                          </b-form-checkbox-group>
                  </b-input-group>
                </b-col>         
            </b-row>
            <b-table
                class="mb-0"
                ref="tableLcy"
                sticky-header="600px" outlined responsive striped hover
                style="font-size:smaller;"
                :items="agingDtl.list"
                :fields="tblDetail.fields"
                :current-page="tblDetail.page"
                :per-page="tblDetail.limit"
                :sort-by.sync="tblDetail.sortBy"
                :sort-desc.sync="tblDetail.sortDesc"
                :filter="filterDtlInput"
                :filterIncludedFields="filterDtlOn"
                @filtered="onFilteredDetail"                 
            >
              <template v-slot:cell(tanggal)="data">
                {{ data.item.tanggal | moment("DD MMM YYYY") }}
              </template>
                <template v-slot:cell(totalinv)="data">
                    {{ data.item.totalinv | numFormat }}
                </template>
                <template v-slot:cell(outstand)="data">
                      {{ data.item.outstand | numFormat }}
                </template>
                <template v-slot:cell(outstandLcy)="data">
                      {{ data.item.outstandLcy | numFormat }}
                </template>
                <template v-slot:cell(aging3Ori)="data">
                      {{ data.item.aging | numFormat }}
                </template>
            </b-table>
            <b-row class="mt-2">
                <b-col cols="4">
                    <div style="font-weight: bolder;">Total Detail Outstanding : {{uanguser}} {{this.agingDtl.outstandLcy | numFormat}}</div>
                </b-col>
                <b-col cols="8">
                    <b-row >
                      <b-col cols="6" style="text-align:center">
                        <div>
                          Showing {{(tblDetail.page - 1) * tblDetail.limit + 1}}
                          to <span v-if="((tblDetail.page * tblDetail.limit)>tblDetail.total)">{{tblDetail.total}}</span> <span v-else>{{tblDetail.page * tblDetail.limit}}</span>
                          of {{tblDetail.total}} entries,   <span class="ml-3 mr-1">limit per page :</span> 
                          <select  v-model="tblDetail.limit"  style="width:60px;">
                            <option>10</option>
                            <option>20</option>
                            <option>30</option>                            
                            <option>40</option>
                            <option>50</option>                            
                            <option>60</option>                            
                            <option>70</option>                            
                            <option>80</option>                            
                            <option>90</option>                            
                            <option>100</option>                            
                          </select>
                        </div>
                        <b-form-checkbox v-model="filterDtlShow" value="Hide" unchecked-value="Show" switch>
                          <b> {{ filterDtlShow }}</b> Filter
                        </b-form-checkbox>
                      </b-col>
                      <b-col cols="6">            
                        <b-pagination 
                          align="right"
                          :total-rows="tblDetail.total"
                          :per-page="tblDetail.limit"
                          v-model="tblDetail.page"
                        ></b-pagination>
                      </b-col>
                    </b-row>
                </b-col>
            </b-row>
          </b-tab>

        </b-tabs>
      </b-card>
    </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
        <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
    <b-modal v-model="showPrintConfirm" title="Print Choices" size="sm"  @ok="print">
      <b-form-radio-group id="chkPrint" name="printMenus" v-model="model.view" stacked>
        <b-form-radio value="Summary in Original Currency">Summary in Original Currency</b-form-radio>
        <b-form-radio value="Summary in Local Currency">Summary in Local Currency</b-form-radio>
        <b-form-radio value="Detail Invoice Outstanding">Detail Invoice Outstanding</b-form-radio>
      </b-form-radio-group>
    </b-modal>
  </div>
</template>


<script>
import moment from 'moment';
import arkoranreport from "../../apis/arkoranreport";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import toastr from "mini-toastr";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    model: {
        tgl2: { required },
    },
  }, 
  data() {
    return {
      horizontal: true,
      isLoading:false,
      showSummary:true,
      showPrintConfirm:false,
      showReport:false,
      reportUrl: null,
      model: {tabIndex:0, account:'',tgl1:'',tgl2:'', exclude:0, excludezero:1},
      uanguser: this.$store.state.user.matauang,
      accounts: [],
      aging : {rekap:[], detail:[], seting:{}},
      agingDtl: {list:[], outstand: 0, outstandLcy: 0},
      subtotal : {},
      tblOri: {
        page: 1,
        limit: 20,
        total: 0,
        sortBy: null,
        sortDesc: false,
        fields:[
          {
            key: "custcode",
            label: "Customer Code",
            thStyle: "width:120px",
            sortable: true
          },
          {
            key: "CustName",
            label: "Customer Name",
            sortable: true
          },
          {
            key: "matauang",
            thStyle: "width:40px",
            label: "$,¥",
            sortable: true
          },
          {
            key: "totalOri",
            label: "Total Outstanding",
            thStyle: "width:150px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "totalLCY",
            label: "Total Outstanding",
            thStyle: "width:150px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "aging1Ori",
            label: "Outstanding",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "aging2Ori",
            label: "Outstanding",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "aging3Ori",
            label: "Outstanding",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "aging4Ori",
            label: "Outstanding",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "aging5Ori",
            label: " > 180 Days",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "aging6Ori",
            label: " > 180 Days",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },

        ]
      },
      tblLcy: {
        page: 1,
        limit: 20,
        total: 0,
        sortBy: null,
        sortDesc: false,
        fields:[
          {
            key: "custcode",
            label: "Customer Code",
            thStyle: "width:120px",
            sortable: true
          },
          {
            key: "CustName",
            label: "Customer Name",
            sortable: true
          },
          {
            key: "totalLcy",
            label: "Total Outstanding",
            thStyle: "width:150px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "aging1Lcy",
            label: "Outstanding",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "aging2Lcy",
            label: "Outstanding",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "aging3Lcy",
            label: "Outstanding",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "aging4Lcy",
            label: "Outstanding",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "aging5Lcy",
            label: " > 180 Days",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "aging6Lcy",
            label: " > 180 Days",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },

        ]
      },
      tblDetail: {
        page: 1,
        limit: 20,
        total: 0,
        sortBy: null,
        sortDesc: false,
        fields:[
          {
            key: "nomor",
            label: "Inv. Number",
            sortable: true
          },
          {
            key: "tanggal",
            label: "Inv. Date",
            sortable: true
          },
          {
            key: "custinfo",
            label: "Customer",
            sortable: true
          },
          {
            key: "ordernumber",
            label: "Order Number",
            sortable: true
          },
          {
            key: "uraian",
            label: "Description",
            sortable: true
          },
          {
            key: "matauang",
            thStyle: "width:40px",
            label: "$,¥",
            sortable: true
          },
          {
            key: "totalinv",
            label: "Total Invoice",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "outstand",
            label: "Outstanding",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "outstandLcy",
            label: "Outstand LCY",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "aging",
            label: "Age (days)",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
        ]
      },
      filter: null,
      filterInput: null,
      filterOn:[] , 
      filterShow:'Show',   
      filterOri: null,
      filterOriInput: null,
      filterOriOn:[] , 
      filterOriShow:'Show',   
      filterDtl: null,
      filterDtlInput: null,
      filterDtlOn:[] , 
      filterDtlShow:'Show',   

    };
  },
  components: {Loading},
  computed: {
    invalidFilter() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    account() {
        return this.model.account;
    },
  },
  watch:{
    account: function(newval) {
      const obj=this.accounts.find(d => d.value === newval);
        this.model.namaacc=obj.text || '';
        this.model.kodeacc=obj.kodeacc;
    },
    filterShow: function(newval) {
      setTimeout(() => {
           if (this.filterShow=='Show') {
             this.filterInput='';
             this.filter='';
            }
      }, 200);
    },
    filter: function(newval) {
      setTimeout(() => {
           if ( this.filterInput!=newval) this.filterInput=newval;
      }, 800);
    },
    filterOriShow: function(newval) {
      setTimeout(() => {
           if (this.filterOriShow=='Show') {
             this.filterOriInput='';
             this.filterOri='';
            }
      }, 200);
    },
    filterOri: function(newval) {
      setTimeout(() => {
           if ( this.filterOriInput!=newval) this.filterOriInput=newval;
      }, 800);
    },


    filterDtlShow: function(newval) {
      setTimeout(() => {
           if (this.filterDtlShow=='Show') {
             this.filterDtlInput='';
             this.filterDtl='';
           }
      }, 200);
    },
    filterDtl: function(newval) {
      setTimeout(() => {
           if ( this.filterDtlInput!=newval) this.filterDtlInput=newval;
      }, 800);
    },

  },  
  created: async function(){
      const accList = await arkoranreport.postgroupkoran();
      this.accounts = accList.reduce((newArr,item) =>{
            newArr.push(item);
            return newArr;
        },[{ value: '', text: '--- ALL ---'}]);
        const tgl2 = moment(this.$store.state.user.tglaktif, 'YYYY-MM-DD').add(1,'M').subtract(1, 'day');
        // this.model.tgl1=this.$store.state.user.tglaktif;
        this.model.tgl2=tgl2.format('YYYY-MM-DD');
        // this.model.tabIndex=0;
  },  
  methods: {
    onFiltered(filteredItems) {
      this.tblLcy.total = filteredItems.length;
      this.tblLcy.page = 1;
    },  
    onFilteredOri(filteredItems) {
      this.tblLcy.total = filteredItems.length;
      this.tblLcy.page = 1;
    },  
    onFilteredDetail(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.tblDetail.total = filteredItems.length;
      this.tblDetail.page = 1;
      this.agingDtl.outstandLcy = filteredItems.reduce((a, b) => a + b.outstandLcy, 0);
    },  

    getData: async function(ctx) {
        if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
       } else {
        this.showSummary=true;
        this.isLoading=true;
        const result = await arkoranreport.agingrekapcust(this.model);
        this.isLoading=false;      
        if (result.success) {
            this.aging.rekap = result.data[0];
            this.agingDtl.list = result.data[1];
            this.agingDtl.outstandLcy = this.agingDtl.list.reduce((a, b) => a + b.outstandLcy, 0);
            this.aging.valas = result.data[2];
            this.aging.seting = result.data[3][0];
            this.aging.rekapVendor = result.data[4];
            this.aging.totalLcy = 0;
            this.aging.aging1Lcy = 0;
            this.aging.aging2Lcy = 0;
            this.aging.aging3Lcy = 0;
            this.aging.aging4Lcy = 0;
            this.aging.aging5Lcy = 0;
            this.aging.rekap.forEach((ap) => {
              this.aging.totalLcy += ap.totalLcy;
              this.aging.aging1Lcy += ap.aging1Lcy;
              this.aging.aging2Lcy += ap.aging2Lcy;
              this.aging.aging3Lcy += ap.aging3Lcy;
              this.aging.aging4Lcy += ap.aging4Lcy;
              this.aging.aging5Lcy += ap.aging5Lcy;
          });
          // this.$forceUpdate();
          this.tblOri.total= this.aging.rekap.length;
          this.tblLcy.total= this.aging.rekap.length;
          if (result.message) toastr.warn(result.message,'WARNING',10000);
        } else {
          if (result.message) toastr.error(result.message,'ERROR',10000);
        }
       }
    },
    getCustDtl: function (row) {
      toastr.warn(row.CustName.toUpperCase(),`Loading Detail Outstanding`);
      setTimeout(() => {
        this.model.tabIndex=2;
        this.filterDtlOn=['custcode'];      
        this.filterDtl=row.custcode;
        this.filterDtlInput=row.custcode;
        this.filterDtlShow='Hide';        
      }, 100);
      // this.$forceUpdate();
    },    
    getDetail: function (row, col) {
      toastr.info("Loading Detail Outstanding");
      this.model.tabIndex=2;
      this.filterDtlOn=['CustName'];      
      this.filterDtl=row.CustName;
      this.filterDtlInput=row.CustName;
      this.filterDtlShow='Hide';
      // this.$forceUpdate();
    },    
    exportxls: async function() {
      if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
      } else {
        this.isLoading=true;
        try {
            const response = await arkoranreport.agingrekapcustexport(this.model);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message,'ERROR',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR',10000);
            }
        }
      }
    },  
    print: async function()
    {
      this.isLoading=true;
      try {
                this.showReport=true;
          this.reportUrl= await arkoranreport.agingrekapcustprint(this.model);
          this.isLoading=false;
              if (this.$isMobile()){
                  this.showReport=false;              
                  window.location.href= `https://docs.google.com/viewerng/viewer?url=${this.reportUrl}`;
              }
      } catch (error) {
          this.isLoading=false;
          if (error.message) {
              toastr.error(error.message,'ERROR',10000);
          } else {
              toastr.error(JSON.stringify(error),'ERROR',10000);
          }
      }
    },    
    printjv: async function()
    {
      if (this.model) {
          try {
              this.showReport=true;
              this.reportUrl= await arkoranreport.printjv(this.model);
          } catch (error) {
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } else {
            toastr.warn('Please select a row that want to be Printed!');
        }
    },
    close(){
      if (this.showSummary===true ) {
          router.push("home");
      } else {
        this.showSummary=true;
      }

    }
  }
};
</script>
